module.exports = __webpack_public_path__ + "img/chartbar.eb6a7941.png";